const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');
/**
 * PreCooked Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Invitations the service defined to manage Invitations
 * @argument {Resource} Overview the resource defined to get Overview queries
 */
app.controller('preCookedController', ['Application', 'Reports', 'ReportsResources', 'Users', 'AccessHelper', '$window', '$document', '$translate', function(Application, Reports, ReportsResources, Users, AccessHelper, $window, $document, $translate) {

    var self = this;
    self.allowance = {
      reports: AccessHelper.isAllowed(['admin', 'reports'], null, ['admin']),
    };

    if (!self.allowance.reports || Application.access.role !== 'admin') {
      Application.navigation.goTo('/explore');
      return;
    }
    self.loading = false;
    self.translations = {};
    self.warning_no_data = false;
    self.activeTab = 'myreports';
    self.isToday = function(date){
      var dates = {
        "incoming": moment(date).format('MM/DD/YYYY'),
        "today":moment().format('MM/DD/YYYY')
      };
      if( dates.incoming === dates.today ){
        return moment(date).subtract(1,'days').format('MM/DD/YYYY')
      };
      return dates.incoming;
    };
    self.arguments = {
      today: moment().format('MM/DD/YYYY'),
      yesterday: moment().subtract(1, 'days').format('MM/DD/YYYY'),
      from_date: moment().subtract(1, 'days').format('MM/DD/YYYY'),
      until_date: moment().subtract(1, 'days').format('MM/DD/YYYY'),
      date_range_days: function() {
        return moment(self.arguments.until_date, 'MM-DD-YYYY').diff(moment(self.arguments.from_date, 'MM-DD-YYYY'), 'days');
      },
      past_days: '7',
      users: '',
      locations: '',
      departments: '',
      placeholder: self.translations['precooked.search_by'],
      clear: false,
      restrictions: {},
      onQuery: function(query_arguments) {
        self.searching = false;
        var user_filter = {
          fields: 'first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name'
        };
        if (!query_arguments || Object.keys(query_arguments).length === 0) {
          self.arguments.users = '';
          self.arguments.locations = '';
          self.arguments.departments = '';
          self.warning_no_data = false;
          return;
        }

        Object.assign(user_filter, query_arguments);

        self.searching = true;
        self.searchLoading = true;
        Users.find(user_filter).$promise.then(function(users) {
          if (!users || users.length === 0) {
            self.warning_no_data = true;
            self.arguments.users = '';
            self.arguments.locations = '';
            self.arguments.departments = '';
            return;
          }
          var ids = users.map(function(user) {
            return user._id;
          });
          self.arguments.users = ids.join(',');
          if (user_filter.linked_locations) {
            self.arguments.locations = user_filter.linked_locations;
          }
          if (user_filter.linked_departments) {
            self.arguments.departments = user_filter.linked_departments;
          }
        });
      }
    };
    self.initialize = function() {
      if (!Application.features.flags().reports) {
        Application.navigation.goToHome();
        return;
      }
      Reports.list().$promise.then(function(list) {
        self.report_list = list;
        self.last_date = list[0].first_date;
      });
    };
    self.getUntilDate = function(index) {
      if (self.arguments.past_days === '110') {
        return moment(self.arguments.until_date, 'MM-DD-YYYY').toDate();
      }
      return self.report_list[index].last_date;
    };
    self.getFromDate = function(index) {
      if (self.arguments.past_days === '110') {
        return moment(self.arguments.from_date, 'MM-DD-YYYY').toDate();
      }
      if (self.arguments.past_days === '100') {
        return self.report_list[index].first_date;
      }
      return moment(self.report_list[index].last_date).subtract(parseInt(self.arguments.past_days), 'day').toDate();
    };
    self.csvReport = function(report_key) {
      self.loading = true;
      //:report/:year/:month/:day
      var fd = moment().subtract(parseInt(self.arguments.past_days), 'day');
      var ud = moment();
      var filter = {
        users: self.arguments.users,
        locations: self.arguments.locations,
        departments: self.arguments.departments
      };
      if (self.arguments.past_days === '100') {
        var fdreport = self.report_list.find(function(report) {
          return report.key === report_key;
        });
        if (fdreport) {
          fd = moment(fdreport.first_date);
        } else {
          fd = moment().subtract(1, 'year');
        }
      }
      if (self.arguments.past_days === '110') {
        if (self.arguments.date_range_days() === 0) {
          Application.messaging.addMessage({type: 'error', text: self.translations['precooked.date_range_same'], duration: 5});
          self.loading = false;
          return;
        }
        fd = moment(self.arguments.from_date, 'MM-DD-YYYY');
        ud = moment(self.arguments.until_date, 'MM-DD-YYYY');
        filter.run_until = ud.format('YYYY') + ud.format('MM') + ud.format('DD');
      }
      ReportsResources.csv({report: report_key, year: fd.format('YYYY'), month: fd.format('MM'), day: fd.format('DD')}, filter).$promise.then(function(result) {
        if (result.status === 404) {
          console.log('No data for that report');
          Application.messaging.addMessage({type: 'info', text: self.translations['precooked.no_data_for_report'], duration: 5});
          self.loading = false;
        }
        if (result.status === 422) {
          console.log('No data for that report');
          Application.messaging.addMessage({type: 'info', text: self.translations['precooked.could_not_build'], duration: 5});
          self.loading = false;
        }
        const blob = new Blob([new Uint8Array(result.data)], {type: result.headers('Content-Type')});

        if ($window.navigator && $window.navigator.msSaveOrOpenBlob) { // for IE
          //msSaveBlob only available for IE & Edge
          $window.navigator.msSaveBlob(blob, report_key + '-report-' + fd.format('YYYYMMDD') + '-' + ud.format('YYYYMMDD') + '.csv');
        } else {

          $window.URL = $window.webkitURL || $window.URL;

          var anchor = $window.document.createElement('a');
          anchor.href = $window.URL.createObjectURL(blob);
          anchor.download = report_key + '-report-' + fd.format('YYYYMMDD') + '-' + ud.format('YYYYMMDD') + '.csv';
          $window.document.body.appendChild(anchor); //For FF
          anchor.target = '_blank';
          anchor.click();
          //It's better to remove the elem
          $window.document.body.removeChild(anchor);
        }
      }).catch(function(error) {
        console.log('Error calling report resource', error);
        Application.messaging.addMessage({type: 'error', text: self.translations['precooked.could_not_download'], duration: 5});
        self.loading = false;
      }).finally(function() {
        self.loading = false;
      });
    };

    $translate([
      'precooked.search_by',
      'precooked.date_range_same',
      'precooked.no_data_for_report',
      'precooked.could_not_build',
      'precooked.could_not_download'
    ]).then(function (translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);